import type { FC, PropsWithChildren } from 'react';
import { SessionTimedOut } from 'components/login/SessionTimedOut';
import { useWorkspace } from 'hooks/useWorkspace';
import React, { useCallback, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { putLocalStorage } from 'utils/localStorage';
import { useAuth0 } from '@auth0/auth0-react';

export const IdleTimerContainer: FC<PropsWithChildren> = ({ children }) => {
  const [isIdle, setIsIdle] = useState(false);

  const onIdleHandler = useCallback(() => {
    setIsIdle(true);
    putLocalStorage('user_redirect_href', { path: window.location.href });
  }, []);

  useIdleTimer({
    timeout: 3 * 60 * 60 * 1000, // 3 hours
    onIdle: onIdleHandler,
    emitOnAllTabs: true,
    eventsThrottle: 1000,
  });

  const { logout } = useAuth0();

  const { workspace } = useWorkspace();

  return workspace && isIdle ? (
    <SessionTimedOut
      onLogin={() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Auth0 navigates away.
        logout({
          logoutParams: { returnTo: `${window.location.origin}/login` },
        });
      }}
    />
  ) : (
    <>{children}</>
  );
};
